export enum ScreenshotType {
  Jpg = 0,
  Png = 1,
  Bmp = 2,
}

export const screenshotTypeExtension: Record<ScreenshotType, string> = {
  [ScreenshotType.Jpg]: "jpg",
  [ScreenshotType.Png]: "png",
  [ScreenshotType.Bmp]: "bmp",
};

export const screenshotTypeMime: Record<ScreenshotType, string> = {
  [ScreenshotType.Jpg]: "image/jpeg",
  [ScreenshotType.Png]: "image/png",
  [ScreenshotType.Bmp]: "image/bmp",
};

export type ScreenshotShotRequest = {
  name: string;
  id: number | null;
  fileName: string;
  type: number;
  payload?: never;
};

export type ScreenshotShotResponse = void;
